import React, { FCC } from 'react'

import { Link } from '@sketch/components'

import { WorkspaceProfileFragment } from '@sketch/gql-types'

import { Container, Text } from './ProfileInfo.styles'
import styled from 'styled-components'

const getShortWebsiteURL = (url: string) =>
  new URL(url).hostname.replace('www.', '')

interface ProfileInfoProps {
  profile: Partial<Pick<WorkspaceProfileFragment, 'description' | 'websiteUrl'>>
}

export const StyledLink = styled(Link)`
  font-weight: ${({ theme }) => theme.fontWeights.regular};

  /** Override parent style and force breaking for very long words */
  &&& {
    white-space: normal;
    word-break: break-all;
  }
`

export const ProfileInfo: FCC<ProfileInfoProps> = ({ profile }) => {
  const { description, websiteUrl } = profile
  const isProfileInfoEmpty = !description && !websiteUrl

  // Avoid the container to render if the user does have profile information
  if (isProfileInfoEmpty) return null

  return (
    <Container>
      {description && <Text>{description}</Text>}
      {websiteUrl && (
        <Text>
          <StyledLink external href={websiteUrl}>
            {getShortWebsiteURL(websiteUrl)}
          </StyledLink>
        </Text>
      )}
    </Container>
  )
}
